<div class="d-flex w-100 h-100">
	<div class="mx-auto my-auto display-10">Please use the payment device to complete your transaction.</div>
</div>
